/**
 * Contact Form Handler
 * Handles AJAX form submission with validation and user feedback
 */

document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('contactForm');

    if (!form) {
        return; // Exit if form not found on page
    }

    // Get translations from global object (set in blade view)
    const translations = window.contactTranslations || {
        nameRequired: 'Please enter your name',
        emailRequired: 'Please enter your email',
        emailInvalid: 'Please enter a valid email address',
        messageRequired: 'Please enter a message',
        messageMin: 'Please enter a message (minimum 10 characters)',
        sending: 'Sending...',
        rateLimit: 'Too many requests. Please try again later.',
        errorGeneral: 'An error occurred. Please try again.'
    };

    /**
     * Clear all error messages
     */
    function clearErrors() {
        const errorMessages = form.querySelectorAll('.error-message');
        errorMessages.forEach(el => {
            el.innerHTML = '';
            el.style.display = 'none';
        });

        // Remove error classes and styles from inputs
        const formControls = form.querySelectorAll('.form-control');
        formControls.forEach(el => {
            el.classList.remove('is-invalid');
            el.style.borderColor = '';
        });
    }

    /**
     * Display validation errors
     */
    function displayErrors(errors) {
        Object.keys(errors).forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                const errorDiv = field.parentElement.querySelector('.error-message');
                if (errorDiv) {
                    errorDiv.innerHTML = `
                        <div style="
                            display: flex;
                            align-items: center;
                            gap: 6px;
                            padding: 8px 12px;
                            background: rgba(220, 53, 69, 0.05);
                            border-radius: 6px;
                            margin-top: 8px;
                        ">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
                                <circle cx="12" cy="12" r="10" stroke="#dc3545" stroke-width="2"/>
                                <path d="M12 8V12M12 16H12.01" stroke="#dc3545" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                            <span style="color: #dc3545; font-size: 0.875rem; font-weight: 500;">${errors[fieldName][0]}</span>
                        </div>
                    `;
                    errorDiv.style.display = 'block';
                }
                field.classList.add('is-invalid');
                field.style.borderColor = '#dc3545';
            }
        });
    }

    /**
     * Show success message
     */
    function showSuccessMessage(message, whatsappUrl = null) {
        const msgSubmit = document.getElementById('msgSubmit');
        const lang = document.documentElement.lang;

        let content = `
            <div style="
                background: linear-gradient(135deg, rgba(40, 167, 69, 0.1), rgba(40, 167, 69, 0.05));
                border-left: 4px solid #28a745;
                padding: 1rem 1.25rem;
                border-radius: 8px;
                display: flex;
                align-items: flex-start;
                gap: 12px;
                box-shadow: 0 2px 8px rgba(40, 167, 69, 0.15);
            ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0; margin-top: 2px;">
                    <circle cx="12" cy="12" r="10" stroke="#28a745" stroke-width="2"/>
                    <path d="M8 12L11 15L16 9" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div style="flex: 1;">
                    <span style="color: #28a745; font-size: 0.95rem; font-weight: 500;">${message}</span>
        `;

        if (whatsappUrl) {
            const whatsappText = lang === 'fr'
                ? 'Continuer sur WhatsApp'
                : 'Continue on WhatsApp';

            content += `
                    <a href="${whatsappUrl}"
                       target="_blank"
                       rel="noopener noreferrer"
                       style="
                           display: inline-flex;
                           align-items: center;
                           gap: 8px;
                           margin-top: 12px;
                           padding: 10px 20px;
                           background: linear-gradient(135deg, #25D366 0%, #128C7E 100%);
                           color: white;
                           text-decoration: none;
                           border-radius: 6px;
                           font-weight: 500;
                           font-size: 0.9rem;
                           transition: transform 0.2s ease;
                       "
                       onmouseover="this.style.transform='translateY(-2px)'"
                       onmouseout="this.style.transform='translateY(0)'">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                        </svg>
                        ${whatsappText}
                    </a>
            `;
        }

        content += `
                </div>
            </div>
        `;

        msgSubmit.innerHTML = content;
        msgSubmit.classList.remove('hidden');
        msgSubmit.style.marginTop = '1.5rem';

        // Hide message after 10 seconds if WhatsApp link, 8 seconds otherwise
        setTimeout(() => {
            msgSubmit.classList.add('hidden');
        }, whatsappUrl ? 12000 : 8000);
    }

    /**
     * Show error message
     */
    function showErrorMessage(message) {
        const msgSubmit = document.getElementById('msgSubmit');
        msgSubmit.innerHTML = `
            <div style="
                background: linear-gradient(135deg, rgba(220, 53, 69, 0.1), rgba(220, 53, 69, 0.05));
                border-left: 4px solid #dc3545;
                padding: 1rem 1.25rem;
                border-radius: 8px;
                display: flex;
                align-items: center;
                gap: 12px;
                box-shadow: 0 2px 8px rgba(220, 53, 69, 0.15);
            ">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style="flex-shrink: 0;">
                    <circle cx="12" cy="12" r="10" stroke="#dc3545" stroke-width="2"/>
                    <path d="M12 8V12M12 16H12.01" stroke="#dc3545" stroke-width="2" stroke-linecap="round"/>
                </svg>
                <span style="color: #dc3545; font-size: 0.95rem; font-weight: 500;">${message}</span>
            </div>
        `;
        msgSubmit.classList.remove('hidden');
        msgSubmit.style.marginTop = '1.5rem';

        // Hide message after 6 seconds
        setTimeout(() => {
            msgSubmit.classList.add('hidden');
        }, 6000);
    }

    /**
     * Basic client-side validation
     */
    function validateForm() {
        const name = form.querySelector('[name="name"]').value.trim();
        const email = form.querySelector('[name="email"]').value.trim();
        const message = form.querySelector('[name="message"]').value.trim();

        if (!name) {
            showErrorMessage(translations.nameRequired);
            return false;
        }

        if (!email) {
            showErrorMessage(translations.emailRequired);
            return false;
        }

        // Basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            showErrorMessage(translations.emailInvalid);
            return false;
        }

        if (!message || message.length < 10) {
            showErrorMessage(translations.messageMin);
            return false;
        }

        return true;
    }

    /**
     * Track form submission with Google Analytics
     */
    function trackSubmission() {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'form_submission', {
                'event_category': 'Contact',
                'event_label': 'Contact Form'
            });
        }
    }

    /**
     * Handle form submission
     */
    form.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Clear previous errors
        clearErrors();

        // Validate form
        if (!validateForm()) {
            return;
        }

        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton.innerHTML;

        // Show loading state
        submitButton.disabled = true;
        submitButton.innerHTML = '<span class="spinner-border spinner-border-sm me-2"></span>' + translations.sending;

        try {
            const formData = new FormData(form);

            const response = await fetch('/api/contact', {
                method: 'POST',
                body: formData,
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    'Accept': 'application/json',
                },
            });

            const result = await response.json();

            if (response.ok) {
                showSuccessMessage(result.message, result.whatsapp_url);
                form.reset();
                trackSubmission();
            } else if (response.status === 422) {
                // Validation errors
                displayErrors(result.errors || {});
            } else if (response.status === 429) {
                // Rate limit exceeded
                showErrorMessage(result.message || translations.rateLimit);
            } else {
                showErrorMessage(result.message || translations.errorGeneral);
            }
        } catch (error) {
            console.error('Form submission error:', error);
            showErrorMessage(translations.errorGeneral);
        } finally {
            // Restore button state
            submitButton.disabled = false;
            submitButton.innerHTML = originalButtonText;
        }
    });

    // Prevent honeypot field from being auto-filled
    const honeypotField = form.querySelector('[name="website"]');
    if (honeypotField) {
        honeypotField.setAttribute('tabindex', '-1');
        honeypotField.setAttribute('autocomplete', 'off');
    }
});
